import { Button } from '@seen/ui'
import { IconCircleCheck, IconX } from '@tabler/icons-react'
import type { JSX } from 'react'

export interface OosaIdtApprovalToastProps {
  title: string
  onViewTask?: () => void
  onDismiss: () => void
}

// Figma 1622:29628 is 640px. Sonner's tray width is --width (356px)
// and right-aligned, so a wider child overflows off-screen. The
// toaster expands via :has([data-oosa-idt-toast]); this toast fills
// that tray instead of setting its own width.
export const oosaIdtApprovalToastOptions = {
  unstyled: true,
  closeButton: false,
  position: 'bottom-right' as const,
}

export function OosaIdtApprovalToast({
  title,
  onViewTask,
  onDismiss,
}: OosaIdtApprovalToastProps): JSX.Element {
  // Figma Green/100, /400, /600 and Grey/800, not the Orbit green scale.
  return (
    <div
      data-oosa-idt-toast=""
      className="flex w-full max-w-[640px] items-center gap-2 rounded-md border border-[#05DF72] bg-[#DCFCE7] px-4 py-3 text-[#292524] shadow-[0_4px_6px_rgba(0,0,0,0.09)]"
    >
      <IconCircleCheck className="size-4 shrink-0 text-[#00A63E]" />
      <p className="min-w-0 flex-1 text-sm leading-5 tracking-[-0.14px]">
        <span className="font-semibold">{title} </span>
        <span>task created.</span>
      </p>
      {onViewTask != null && (
        <Button
          type="button"
          variant="ghost"
          className="h-auto min-w-16 shrink-0 px-4 py-2 text-sm leading-5 font-semibold text-[#292524] hover:bg-transparent"
          onClick={onViewTask}
        >
          View Task
        </Button>
      )}
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="size-4 min-w-4 shrink-0 hover:bg-transparent"
        aria-label="Dismiss"
        onClick={onDismiss}
      >
        <IconX className="size-4" />
      </Button>
    </div>
  )
}
